import FavoriteStar from "components/sidebar/BusItem/FavoriteStar";
import React from "react";
import { Marker } from "react-map-gl";
import { ScopedBus } from "types/busType";
import "./FavoriteBusMarker.scss";

// Favorites draw as white stars with a capacity-colored outline, kept thin so
// the white middle stays visible on the star's narrow points.
const STAR_VIEWBOX = 24;
const STAR_FILL = "#FFFFFF";
const STAR_SIZE = 27;
const STAR_STROKE_PX = 3;
// Selected stars grow and thicken, mirroring the circle layer.
const STAR_SIZE_SELECTED = 34;
const STAR_STROKE_PX_SELECTED = 5;

// stroke-width is in viewBox units, so scale it to hit the given px thickness.
const strokeWidthForSize = (strokePx: number, size: number): number =>
    (strokePx * STAR_VIEWBOX) / size;

type FavoriteBusMarkerProps = {
    readonly scopedBus: ScopedBus;
    readonly color: string;
    readonly isSelected: boolean;
    readonly onSelect: () => void;
};

const FavoriteBusMarker: React.FC<FavoriteBusMarkerProps> = ({
    scopedBus,
    color,
    isSelected,
    onSelect
}) => {
    const size = isSelected ? STAR_SIZE_SELECTED : STAR_SIZE;
    const strokeWidth = strokeWidthForSize(
        isSelected ? STAR_STROKE_PX_SELECTED : STAR_STROKE_PX,
        size
    );

    return (
        <Marker
            longitude={scopedBus.bus.longitude}
            latitude={scopedBus.bus.latitude}
            onClick={(event) => {
                event.originalEvent.stopPropagation();
                onSelect();
            }}
        >
            <FavoriteStar
                className="FavoriteBusMarker-star"
                size={size}
                fillColor={STAR_FILL}
                strokeColor={color}
                strokeWidth={strokeWidth}
            />
        </Marker>
    );
};

export default FavoriteBusMarker;
